module.exports = __webpack_public_path__ + "img/consultation-fee-desktop-en.be9afc94.jpg";